export enum StatusTypes {
  done = 'DONE',
  failed = 'FAILED',
  uploading = 'UPLOADING',
  none = 'NONE',
}
